(function () {
    'use strict';

    function extractSurveyQuestion() {
        const surveyCapture = document.querySelector('[data-oke-survey-capture]');
        if (!surveyCapture) {
            return null;
        }

        // Try multiple selectors
        let questionTitle = surveyCapture.querySelector('.c-questions-header-title');

        if (!questionTitle) {
            questionTitle = surveyCapture.querySelector('.c-title');
        }
        if (!questionTitle) {
            questionTitle = surveyCapture.querySelector('[id*="title"]');
        }
        if (!questionTitle) {
            questionTitle = surveyCapture.querySelector('legend');
        }
        if (!questionTitle) {
            // Try to find any element with class containing "title" or "question"
            questionTitle = surveyCapture.querySelector('[class*="title"], [class*="question"]');
        }

        if (questionTitle) {
            const text = questionTitle.textContent.trim();
            return text;
        }

        return null;
    }

    function updateFAB() {
        const question = extractSurveyQuestion();
        if (!question) {
            return false;
        }

        const fab = document.getElementById('okendo-survey-fab');
        if (!fab) {
            return false;
        }

        const questionElement = fab.querySelector('.okendo-survey-fab__question');
        if (questionElement) {
            questionElement.textContent = question;
            return true;
        }
        return false;
    }

    function openSurvey() {
        const surveyCapture = document.querySelector('[data-oke-survey-capture]');
        if (!surveyCapture) return;

        // Find the actual survey container
        const survey = surveyCapture.querySelector('.l-onsite');
        if (survey) {
            survey.style.display = 'block';
        }
        surveyCapture.style.display = 'block';

        // Hide the FAB permanently once survey is opened
        const fab = document.getElementById('okendo-survey-fab');
        if (fab) {
            fab.style.display = 'none';
        }
        document.body.classList.remove('okendo-survey-loaded');
    }

    function closeFAB() {
        const fab = document.getElementById('okendo-survey-fab');
        if (fab) {
            fab.style.display = 'none';
        }
        document.body.classList.remove('okendo-survey-loaded');
    }

    function setupFABClickHandler() {
        const fab = document.getElementById('okendo-survey-fab');
        if (!fab) {
            return;
        }

        const fabButton = fab.querySelector('.okendo-survey-fab__button');
        const closeButton = fab.querySelector('.okendo-survey-fab__close');

        if (fabButton) {
            fabButton.addEventListener('click', openSurvey);
        }

        if (closeButton) {
            closeButton.addEventListener('click', function (e) {
                e.stopPropagation();
                closeFAB();
            });
        }
    }

    function initializeSurvey() {
        const surveyCapture = document.querySelector('[data-oke-survey-capture]');

        if (surveyCapture) {
            // Check for both pop-over and modal versions
            const lOnsite = surveyCapture.querySelector('.l-onsite');

            if (lOnsite) {
                // Wait 3 seconds for Okendo survey to fully load
                setTimeout(function () {
                    // Try to extract and update FAB with question
                    if (updateFAB()) {
                        // Only show FAB if question was successfully extracted
                        document.body.classList.add('okendo-survey-loaded');
                        setupFABClickHandler();
                    }
                }, 3000);

                return true;
            }
        }
        return false;
    }

    // Wait for DOM to be ready
    function init() {
        // Check immediately
        if (initializeSurvey()) {
            return;
        }

        // If not found, observe for changes
        const observer = new MutationObserver(function (mutations) {
            if (initializeSurvey()) {
                observer.disconnect();
            }
        });

        // Start observing the document body for added nodes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
